export default __webpack_public_path__ + "assets/images/729cb2fb3928b3edcfb1e51055337a77.svg";